/**
 * Created by Christof Sander on 16.02.2017.
 */

const utils = require('frontend-controller/lib/utils');

module.exports = {
	config: {
		swipeMinDistance: 0.2,
		mobileWidthFromGridMarginFactor: {
			// height: .04
		},
		transitions: {
			slider: {
				ease: Cubic.easeInOut,
				duration: 0.4
			},
			column: {
				ease: Cubic.easeInOut,
				duration: 0.4
			}
		},
		showFrame: false,
		galleryFullHeight: false,
		galleryLandscapeCustomHeight: false,
		landscapeRatio: 16 / 10 // 4 / 3
	},

	model: {
		nrOfColumns: 0,
		activeColumnIndex: 0,
		gridDimensions: {},
		columnDimensions: {},
		rowDimensions: {
			width: 0,
			height: 0
		},
		sliderDimensions: {
			width: 0,
			delta: 0
		},
		sliderDraggable: null,
		columnDraggable: null,
		$slider: null,
		$sliderWrapper: null,
		$columnWrapper: null
	},

	events: {
		scroll: {
			type: 'mousewheel DOMMouseScroll',
			action: function(event){
				var nextColumnIndex;
				if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
					if(event.data.component.model.activeColumnIndex == 0){
						// let the column scroll up
						return;
					}
					nextColumnIndex = event.data.component.model.activeColumnIndex - 1;
				}
				else {
					if(event.data.component.model.activeColumnIndex == event.data.component.model.nrOfColumns - 1){
						// let the column scroll down
						return;
					}
					nextColumnIndex = event.data.component.model.activeColumnIndex + 1;
				}

				event.preventDefault();
				event.stopImmediatePropagation();
				event.data.component.moveTo(nextColumnIndex);
			}
		}
	},

	methods: {

		/**
		 * this function will be called when the grid has been updated by the grid-navigator.
		 *
		 * @param   gridDimensions      {} - actual gridDimensions
		 */
		onGridUpdate: function(gridDimensions){
			this.model.gridDimensions = utils.copy(gridDimensions);
			this.model.columnDimensions = utils.copy(gridDimensions);

			// tell dom elements the new dimensions
			this.updateDimensions();
		},

		updateDimensions: function(){
			if(!this.model.gridDimensions)  		return;
			if(!this.model.gridDimensions.width)  	return;
			if(!this.model.gridDimensions.height)  	return;
			if(!this.model.nrOfColumns)     		return;
			if(this.model.$slider && this.model.$slider.length <= 0)                 return;
			if(this.model.$columns && this.model.$columns.length <= 0)               return;
			if(this.model.$columnWrapper && this.model.$columnWrapper.length <= 0)   return;

			// prevent gridDimensions reference errors
			this.model.columnDimensions.width = this.model.gridDimensions.width;
			this.model.columnDimensions.height = this.model.gridDimensions.height;

			if(this.model.gridNavigator && (this.model.gridNavigator.model.additionalStyles || []).indexOf('windowPadding') > -1){
				this.model.columnDimensions.width -= 40;
			}

			if(this.activeEnvironment.style === 'mobile'){
				if(this.config.mobileWidthFromGridMarginFactor.width) 		this.model.columnDimensions.width -= Math.round(this.model.gridDimensions.width * this.config.mobileWidthFromGridMarginFactor.width);
				else if(this.config.mobileWidthFromGridMarginFactor.height) this.model.columnDimensions.width -= Math.round(this.model.gridDimensions.height * this.config.mobileWidthFromGridMarginFactor.height);
			}

			if(this.config.galleryLandscapeCustomHeight){
				this.model.columnDimensions.height = this.model.columnDimensions.width / this.config.landscapeRatio;
			}

			this.model.rowDimensions.width  = this.model.nrOfColumns * this.model.columnDimensions.width;
			this.model.rowDimensions.height = this.model.columnDimensions.height;

			this.model.sliderDimensions.width   = Math.round(this.model.columnDimensions.width / Math.min(5, this.model.nrOfColumns));
			this.model.sliderDimensions.delta   = Math.round((this.model.columnDimensions.width - this.model.sliderDimensions.width) / (this.model.nrOfColumns - 1));

			if(this.model.sliderDraggable){
				this.model.sliderDraggable.applyBounds({
					minX: 0,
					maxX: this.model.columnDimensions.width - this.model.sliderDimensions.width
				});
			}

			// set new sliders' width
			if(this.model.nrOfColumns > 0){
				this.model.$sliderWrapper.show();

				TweenMax.set(
					this.model.$slider,
					{
						width: this.model.sliderDimensions.width
					}
				);
			}
			else {
				this.model.$sliderWrapper.hide();
			}

			// set new columnWrappers' width
			TweenMax.set(
				this.model.$columnWrapper,
				{
					width: this.model.rowDimensions.width,
					height: this.model.rowDimensions.height
				}
			);

			// set new columns' width
			TweenMax.set(
				this.model.$columns,
				{
					width: this.model.columnDimensions.width
				}
			);

			// set frames height if necessary
			if(this.model.$frame && this.model.$frame.length > 0){
				TweenMax.set(
					this.model.$frame,
					{
						height: this.model.columnDimensions.height
					}
				);
			}

			// refresh column position after grid-update
			this.moveTo();
		},

		moveTo: function(columnIndex){
			// init
			if(!columnIndex && columnIndex !== 0)           columnIndex = this.model.activeColumnIndex;
			else if(columnIndex < 0)                        columnIndex = this.model.nrOfColumns - 1;
			else if(columnIndex >= this.model.nrOfColumns)  columnIndex = 0;

			this.model.$columns.removeClass('actual');
			this.model.$columns.filter(':nth-of-type(' + (columnIndex + 1) + ')').addClass('actual');

			// init calc
			this.model.columnWrapperX       = -(columnIndex * this.model.columnDimensions.width);
			this.model.sliderX              = (columnIndex * this.model.sliderDimensions.delta);
			this.model.activeColumnIndex    = columnIndex;

			// prevent round off problems for slider position
			if(columnIndex == (this.model.nrOfColumns - 1)){
				this.model.sliderX          = (this.model.columnDimensions.width - this.model.sliderDimensions.width);
			}

			// set new columnWrappers' position
			TweenMax.to(
				this.model.$columnWrapper,
				this.config.transitions.column.duration,
				{
					ease:   this.config.transitions.column.ease,
					x:      this.model.columnWrapperX
				}
			);

			// set new sliders' position
			TweenMax.to(
				this.model.$slider,
				this.config.transitions.slider.duration,
				{
					ease:   this.config.transitions.slider.ease,
					x:      this.model.sliderX
				}
			);
		},



		///////////////////////////////////////////
		///// DRAGGABLE HANDLING
		///////////////////////////////////////////

		onSliderDragStart: function (component) {
			component.model.columnComponent.blockDrag();
			component.model.$sliderWrapper.addClass('active');
		},
		onSliderDrag: function (component) {
			var nextColumnIndex, wrapperX;
			if(
				(nextColumnIndex = Math.round(this.x / component.model.sliderDimensions.delta)) > -1 &&
				nextColumnIndex < component.model.nrOfColumns &&
				(wrapperX = -parseInt(nextColumnIndex * component.model.columnDimensions.width)) < 1
			){
				TweenMax.to(
					component.model.$columnWrapper,
					component.config.transitions.column.duration,
					{
						ease:   component.config.transitions.column.ease,
						x:      wrapperX
					}
				);
			}
		},
		onSliderDragEnd: function (component) {
			component.model.$sliderWrapper.removeClass('active');

			var nextColumnIndex = Math.round(this.x / component.model.sliderDimensions.delta);
			if(nextColumnIndex < 0) {
				nextColumnIndex = 0;
			}
			else if (nextColumnIndex >= component.model.nrOfColumns){
				nextColumnIndex = component.model.nrOfColumns - 1;
			}
			component.moveTo(nextColumnIndex);

			component.model.columnComponent.freeDrag();
		},

		onColumnDragStart: function (component) {
			component.model.nrOfDrags = 0;
			// remember original pointerEvent for a potential handover to the columnComponent
			this.startPointerEvent = this.pointerEvent;
			component.model.columnComponent.blockDrag();
		},
		onColumnDrag: function (component) {
			// check if user wants to drag vertical. if so the parent column within the grid may want to start dragging.
			// NOTE:    this is only possible if this draggable is disabled, because of the x-axis is locked and this draggable is in charge.
			//          therefor this component has to be enabled afterwards which is done by the callback function.
			// NOTE:    the greensock draggables do not move (delta-axis) on a locked axis when the pointer-movement is more than 45 degrees apart from the axis bearing.
			//          so the basic idea of this code is to wait some amount of onDrag-events if there can be seen some delta.
			//          after some testing it could be seen that usually the first onDrag-event carries some delta of (one or two pixels) if the user really wants to move within the locked-axis direction.
			component.model.nrOfDrags++;
			if(component.model.nrOfDrags > 3 && Math.abs(this.x - this.startX) == 0){
				this.disable();
				var self = this;
				component.model.columnComponent.freeDrag();
				component.model.columnComponent.startWindowDrag(this.startPointerEvent, function(){
					self.enable();
				});
				this.endDrag();
			}
		},
		onColumnDragEnd: function (component) {
			// init
			var deltaX;
			var nextColumnIndex         = component.model.activeColumnIndex;
			var usedSwipeMinDistance    = component.config.swipeMinDistance;
			var scrollToNextColumn      = false;

			// upwards
			if((deltaX = (this.startX - this.x)) < 0){
				scrollToNextColumn = (--nextColumnIndex >= 0);
			}
			// downwards
			else if(deltaX > 0) {
				scrollToNextColumn = (++nextColumnIndex < component.model.nrOfColumns);
			}

			// min swipe distance reached?
			if(scrollToNextColumn) {
				if(Math.abs(deltaX / component.model.columnDimensions.width) < usedSwipeMinDistance){
					scrollToNextColumn = false;
				}
			}

			// scroll to actual or next window
			component.moveTo(scrollToNextColumn ? nextColumnIndex : undefined);

			component.model.columnComponent.freeDrag();
		}
	},

	hooks: {
		attach: function($element, options){
			// init
			var self = this;

			if(!options.refresh){
				// register as grid-dependent
				this.closest('layouts_gridNavigator_gridNavigator', function(gridComponent){
					self.model.gridNavigator = gridComponent;
					self.model.gridNavigator.registerGridDependent(self.componentIndex);
				});
			}

			this.model.activeColumnIndex    = 0;
			this.model.nrOfColumns          = utils.collectionSize(this.model.images);
			this.model.$columnWrapper       = this.$.find('.galleryColumnWrapper');
			this.model.$columns             = this.model.$columnWrapper.find('.templates_sliderGallery_image');
			this.model.$sliderWrapper       = this.$.find('.gallerySliderWrapper');
			this.model.$slider              = this.model.$sliderWrapper.find('.gallerySlider');
			this.model.$frame 				= this.$.find('.frame');
			this.closest('layouts_column_column', function(columnComponent){
				self.model.columnComponent = columnComponent;
			});

			if(this.model.$columnWrapper && this.model.$columnWrapper.length > 0){
				if(self.model.sliderDraggable) self.model.sliderDraggable.kill();

				self.model.sliderDraggable = Draggable.create(
					self.model.$slider,
					{
						type: "x",
						edgeResistance: 0.85,
						lockAxis: true,
						cursor: 'auto',

						onDragStart:        self.onSliderDragStart,
						onDragStartParams:  [self],
						onDrag:             self.onSliderDrag,
						onDragParams:       [self],
						onDragEnd:          self.onSliderDragEnd,
						onDragEndParams:    [self]
					}
				)[0];

				if(self.model.columnDraggable) self.model.columnDraggable.kill();
				self.model.columnDraggable = Draggable.create(
					self.model.$columnWrapper,
					{
						type: "x",
						edgeResistance: 0.85,
						lockAxis: true,
						cursor: 'auto',

						onDragStart:        self.onColumnDragStart,
						onDragStartParams:  [self],
						onDrag:             self.onColumnDrag,
						onDragParams:       [self],
						onDragEnd:          self.onColumnDragEnd,
						onDragEndParams:    [self]
					}
				)[0];
			}

			this.updateDimensions();
		}
	}
};
